// Paleta de cores do BoletoXCrypto
export const colors = {
  // Cores principais da marca com variações
  primary: {
    main: '#00A86B',         // verde esmeralda (cor principal)
    light: '#7FDCB6',        // verde claro
    lighter: '#D0F2E6',      // verde muito claro
    dark: '#007C4F',         // verde escuro
    darker: '#005A3A',       // verde muito escuro
  },
  secondary: {
    main: '#F7931A',         // laranja bitcoin (cor de destaque)
    light: '#FFBB66',        // laranja claro
    lighter: '#FFE8CC',      // laranja muito claro
    dark: '#E58108',         // laranja escuro
    darker: '#B36500',       // laranja muito escuro
  },
  
  // Verdes - escala completa
  green: {
    50: '#E8F5E9',           // fundo muito claro
    100: '#C8E6C9',          // fundo claro
    200: '#A5D6A7',          // elementos sutis
    300: '#81C784',          // elementos médios
    400: '#66BB6A',          // elementos destacados
    500: '#4CAF50',          // padrão
    600: '#43A047',          // hover
    700: '#388E3C',          // ativo/pressionado
    800: '#2E7D32',          // destaque forte
    900: '#1B5E20',          // texto sobre fundo claro
  },
  
  // Laranja Bitcoin - escala completa
  bitcoin: {
    50: '#FFF8E1',           // fundo muito claro
    100: '#FFECB3',          // fundo claro
    200: '#FFE082',          // elementos sutis
    300: '#FFD54F',          // elementos médios
    400: '#FFCA28',          // elementos destacados
    500: '#FFC107',          // padrão
    600: '#FFB300',          // hover
    700: '#FFA000',          // ativo/pressionado
    800: '#FF8F00',          // destaque forte
    900: '#F7931A',          // laranja Bitcoin oficial
  },
  
  // Cinzas neutros
  gray: {
    50: '#FAFAFA',           // fundo muito claro
    100: '#F5F5F5',          // fundo claro
    200: '#EEEEEE',          // bordas sutis
    300: '#E0E0E0',          // bordas
    400: '#BDBDBD',          // elementos desabilitados
    500: '#9E9E9E',          // texto secundário
    600: '#757575',          // texto terciário
    700: '#616161',          // texto secundário forte
    800: '#424242',          // texto principal
    900: '#212121',          // texto de destaque
  },
  
  // Cores de status
  status: {
    pending: '#FFC107',      // amarelo para pendente
    confirmed: '#4CAF50',    // verde para confirmado
    cancelled: '#F44336',    // vermelho para cancelado
    locked: '#2196F3',       // azul para travado
    processing: '#9C27B0',   // roxo para processando
  },
  
  // Cores de feedback
  feedback: {
    success: '#4CAF50',      // sucesso
    error: '#F44336',        // erro
    warning: '#FF9800',      // aviso
    info: '#2196F3',         // informação
  },
  
  // Cores básicas
  white: '#FFFFFF',          // branco puro
  black: '#000000',          // preto puro
};

export default colors;
